export default __webpack_public_path__ + "static/media/4.37528886.png";